import React, { useEffect, useState, useRef } from "react";
import {
  delete_icon,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { data, useNavigate } from "react-router-dom";
import CommonMuiTable, { Table } from "../../components/Table/Table";
import { admin_list } from "../redux/api/dummyJson";
import Topbar from "../../components/Topbar/Topbar";
import { URLS } from "../../Services/Constant";
import { deletes, get, post } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";

const Roles = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(""); // ✅ New state
  const [deleteConfirm, setDeleteConfirm] = useState({ open: false, id: null });

  const [list, setList] = useState([]);
  const [popup, setPopup] = useState(false);
  const [page, setPage] = useState(1);
  const debounceTimer = useRef(null); // ✅ Ref to hold the timer

  // ✅ Debounce effect: updates debouncedSearch 500ms after user stops typing
  useEffect(() => {
    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(debounceTimer.current); // cleanup on unmount
  }, [search]);

  // ✅ API call now triggers on debouncedSearch, not search
  useEffect(() => {
    getList();
  }, [debouncedSearch]);

  const getList = async () => {
    let res = await get(
      `${URLS.ROLE_LIST}${debouncedSearch ? `?search=${debouncedSearch}` : ""}`,
    );
    console.log("roles res", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setList(res?.data ?? []);
    }
  };

  const handleStatus = async (id, status) => {
    if (!checkPermission("CAN-STATUS-ADMIN_ROLES")) return;
    let res = await post(URLS.ROLE_STATUS, { id: id, status: !status });
    if (res?.status === "success") {
      toast.success(res?.message);
      getList();
    }
  };

  // const handleDelete = async (id) => {
  //   if (!checkPermission("CAN-DELETE-ADMIN_ROLES")) return;
  //   let res = await deletes(`${URLS.DELETE_ROLE}${id}/`);
  //   if (res?.status === "success") {
  //     toast.success("Role Deleted Successfully");
  //     getList();
  //   }
  // };
  const handleDeleteClick = (id) => {
    if (!checkPermission("CAN-DELETE-ADMIN_ROLES")) return;
    setDeleteConfirm({ open: true, id });
  };

  const handleDeleteConfirm = async () => {
    const { id } = deleteConfirm;
    setDeleteConfirm({ open: false, id: null }); // close modal first

    let res = await deletes(`${URLS.DELETE_ROLE}${id}/`);
    if (res?.status === "success") {
      toast.success("Role Deleted Successfully");
      getList();
    }
  };

  const handleDeleteCancel = () => {
    setDeleteConfirm({ open: false, id: null });
  };

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          return <p className="red">{row.index + 1 + (page - 1) * 10}</p>;
        },
      },
      {
        Header: "Role",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (
                    checkPermission("CAN-STATUS-ADMIN_ROLES") &&
                    row.original?.name !== "Super Admin"
                  )
                    handleStatus(row.original.id, value);
                }}
                style={{
                  background: row.original?.name == "Super Admin" ? "#ddd" : "",
                }}
                className={`${
                  value ? "active-btn" : "deactive-btn"
                } border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
                disabled={row.original?.name == "Super Admin"}
              >
                {value ? " Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
    ];

    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return row.original?.name === "Super Admin" ? null : (
          // return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              {checkPermission("CAN-EDIT-ADMIN_ROLES") && (
                <button
                  onClick={() => {
                    navigate("/add-roles", {
                      state: { type: "edit", data: row.original },
                    });
                  }}
                  className="cust-btn"
                >
                  <img src={edit_icon} alt="" className="edit-btn" />
                </button>
              )}
              {checkPermission("CAN-DELETE-ADMIN_ROLES") && (
                <button
                  onClick={() => handleDeleteClick(row.original.id)}
                  className="cust-btn"
                >
                  <img src={delete_icon} alt="" className="edit-btn" />
                </button>
              )}
            </div>
          </React.Fragment>
        );
      },
    };

    return checkPermission("CAN-EDIT-ADMIN_ROLES") ||
      checkPermission("CAN-DELETE-ADMIN_ROLES")
      ? [...d, action]
      : d;
  }, [page]);

  return (
    <div>
      <Topbar header={"Roles List"} />
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
          Total:{count}
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              onChange={(e) => setSearch(e.target.value)} // ✅ Only updates search state
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              value={search}
            />
            <img alt="" src={Search_icon} className="search" />
          </div>
          {checkPermission("CAN-ADD-ADMIN_ROLES") && (
            <button
              onClick={() => navigate("/add-roles", { state: { type: "add" } })}
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
            >
              + Add Roles
            </button>
          )}
        </div>
      </div>
      <Table
        columns={columns}
        data={list}
        pageno={page}
        setPageno={setPage}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => setPopup(false)}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      {deleteConfirm.open && (
        <div className="img-popup-design">
          <div className="img-popup">
            <h2 className="f4 ms-2 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-16 fs-md-18 fs-lg-18 fs-xl-18 fs-xxl-18 mt-4">
              Delete Role
            </h2>
            <p className="f3 ms-2 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure you want to delete this role? This action cannot be
              undone.
            </p>
            <div
              className="flex gap-3"
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "center",
                marginTop: 10,
              }}
            >
              <button onClick={handleDeleteCancel} className="back-btn f2 w-10">
                No, Cancel
              </button>
              <button onClick={handleDeleteConfirm} className="add-btn w-30">
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Roles;
